"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.stagingAlertName = exports.currentDomain = exports.adminDomain = exports.clientDomain = exports.isAdminDomain = void 0;
const isLocal = location.hostname === "localhost";
const _isAdminDomain = location.hostname.startsWith("admin");
exports.isAdminDomain = isLocal || _isAdminDomain || undefined;
// export const isClientDomain = isLocal || !_isAdminDomain || undefined;
exports.clientDomain = (() => {
    if (!exports.isAdminDomain) {
        return `${window.location.protocol}//${window.location.host}`;
    }
    else {
        return `${window.location.protocol}//${window.location.host.replace(/^admin\./, "")}`;
    }
})();
exports.adminDomain = (() => {
    if (exports.isAdminDomain) {
        return `${window.location.protocol}//${window.location.host}`;
    }
    else {
        return `${window.location.protocol}//admin.${window.location.host}`;
    }
})();
const currentDomain = () => {
    return `${window.location.protocol}//${window.location.host}`;
};
exports.currentDomain = currentDomain;
exports.stagingAlertName = (() => {
    if (location.hostname.includes("staging")) {
        return "staging";
    }
    else if (location.hostname.includes("preview")) {
        return "preview";
    }
    else if (location.hostname.includes("dev")) {
        return "dev";
    }
    else if (location.hostname.includes("localhost")) {
        return "local";
    }
    else if (location.hostname === "dre-magi-translate.web.app") {
        return undefined;
    }
    else if (location.hostname.endsWith(".web.app")) {
        // get first phrase before hypen
        return location.hostname.split("-")[0];
    }
    else {
        return undefined;
    }
})();
